import { useEffect, useRef } from "react";
import { Narrative } from "../store/adsPageStore";

export function useNarrativeScroll(selectedNarrative: Narrative | null) {
  const refs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  useEffect(() => {
    if (selectedNarrative?.id) {
      const selectedRef = refs.current[selectedNarrative.id];
      if (selectedRef) {
        selectedRef.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [selectedNarrative]);

  const registerRef = (id: string) => (el: HTMLDivElement | null) => {
    refs.current[id] = el;
  };

  return { registerRef };
}
